<template lang="pug">
  include Promotion.pug
</template>

<script type="text/javascript">
import _ from "underscore"
import Lockr from "lockr"
import api from "@/service/api"
import utils from "@/service/utils"
import { mapState } from "vuex";

export default {
  name: "Promotion",
  props: ["uuid"],
  computed: _.extend({
    valid: function() {
      if (!this.promotion) return false
      if (!this.promotion.include_book) return true

      if (_.isEmpty(this.address1)) return false
      if (_.isEmpty(this.name)) return false
      if (_.isEmpty(this.city)) return false
      if (_.isEmpty(this.phone)) return false
      if (_.isEmpty(this.zipcode)) return false
      if (_.isEmpty(this.administrative_zone)) return false

      return true
    }
  }, mapState([
    "token",
    "username",
    "promo"
  ])),
  data() {
    return {
      promotion: null,
      address1: "",
      address2: "",
      name: "",
      city: "",
      phone: "",
      zipcode: "",
      administrative_zone: "",
    }
  },
  async created() {
    const promoResponse = await api.promotion(this.uuid)
    this.promotion = promoResponse.data
  },
  methods: {
    warn: function() {
      alert("Por favor, rellene el formulario de datos con su dirección para poder envirárselo el libro")
    },
    pay: async function() {
      if (!this.token) {
        // Must login
        Lockr.set("cop_promo", this.uuid)
        this.$router.push({
          name: "Login",
        });
      } else {
        // already login
        const addressData = {
          address1: this.address1,
          address2: this.address2,
          name: this.name,
          zipcode: this.zipcode,
          city: this.city,
          administrative_zone: this.administrative_zone,
          phone: this.phone,
        }
        const response = await api.createPromotion(this.token, this.uuid, addressData)
        const data = response.data
        const linkPayment = data.link_payment
        Lockr.rm("cop_promo")
        window.location.href = linkPayment
      }
    }
  },
  filters: {
    price: (newValue) => {
      return utils.price(newValue)
    },
    originalprice: (newValue) => {
      return utils.originalPrice(newValue)
    }
  }
}
</script>
